import React from 'react';
import PropTypes from 'prop-types';

const NoSurveyTemplateError = ({ isSurveyTemplateQuestion, errorText }) => {
  if (isSurveyTemplateQuestion)
    return null;
  return (<div className="no-template-error">
    {errorText}
  </div>);
};

export default NoSurveyTemplateError;

NoSurveyTemplateError.propTypes = {
  isSurveyTemplateQuestion: PropTypes.bool,
  errorText: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/components/charts/NoSurveyTemplateError.js